// @flow
import createAction from '../../../../../util/createAction';

export const SELECT_PRODUCT = 'marketplace/recommended/select-product';

export const selectProduct = createAction(SELECT_PRODUCT);
